import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonModal,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import ErrorTopToaster from "../../components/ErrorTopToaster";
import CancelModal from "../../components/modals/cancel-modal";
import { ActionType, MailType } from "../../models/Enums";
import {
  ForgotPasswordAuth,
  GetUserByEmail,
} from "../../services/AuthServices";
import React from "react";
import { newUser } from "../../models/User";
import { useRecoilState } from "recoil";
import { networkConnectionStatus, newUserState } from "../../data/atoms";
import { getMobileUIVersion } from "../../utils/api-interceptor";
import LoaderModalComponent from "../../components/modals/LoaderModal";
import TopLeftUserName from "../../components/TopLeftUserName";
import ExitModal from "../../components/modals/exit-modal";
import AccountErrorModal from "../../components/modals/account-error-modal";

interface Props {
  actionType: any;
}

const ForgotPassword: React.FC<Props> = ({ actionType }) => {
  actionType = actionType?.actionType;
  const [NewUser, setNewUser] = useRecoilState(newUserState);
  const [isDisabled, setIsDisabled] = useState(true);
  const [cancelModal, setShowModal1] = useState(false);
  const [loaderModal, setloaderModal] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const [AccountError, setAccountError] = useState(false);
  const [isDuplicateModal, setIsDuplicateModal] = useState(false);
  let history = useHistory();
  const {
    register,
    setError,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  let location =
    window.location.href === window.location.origin + "/email" ? true : false;

  useEffect(() => {
    reset();
  }, [location]);

  async function checkDisableTextValidity(typedValue: string) {
    setValue("email", typedValue);
    if (typedValue !== "" && typedValue.trim().length !== 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }

  function handleChange(event: any) {
    checkDisableTextValidity(event.target.value);
  }

  function clickChange(email: string) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setIsDisabled(true);
    // console.log("actionType", actionType)
    if (actionType == ActionType.NewUser) {
      getUserByEmail(email);
    } else {
      ResetPassword(email);
    }
  }

  async function ResetPassword(email: string) {
    try {
      await ForgotPasswordAuth({
        Email: email,
        MailType: MailType.ResetCodeEmail,
      })
        .then(function (response: any) {
          debugger;
          if (response!.data.responseCode === 1) {
            localStorage.setItem("UserID", response!.data.id);
            localStorage.setItem("TokenID", response!.data.token);
            localStorage.setItem("LocationId", response!.data.locationId);
            localStorage.setItem("WorkstationId", response!.data.workstationId);
            localStorage.setItem("resetEmail", email);
            localStorage.setItem("Username", response!.data.responseMessage);
            localStorage.setItem(
              "EncryptedServerId",
              response!.data.encryptedServerId
            );
            localStorage.setItem("BusinessType", response!.data.businessType);
            reset();
            history.replace("/code", { actionType: ActionType.ForgotPassword });
            // history.push("/code", { actionType: ActionType.ForgotPassword });
          } else {
            setError("email", {
              type: "server",
              message:
                "The Email entered is not recognized. Please contact your administrator",
              // message: response.data!.responseMessage
              // message: "Unable to send email",
            });
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  // useEffect(() => {
  //   getMobileUIVersion();
  // }, [])

  async function getUserByEmail(email: string) {
    try {
      await GetUserByEmail({
        email: email,
      })
        .then(function (response) {
          if (response!.data.responseCode == 1) {
            reset();
            setNewUser(response!.data.user as newUser);
            console.log("actiontype email", actionType);
            localStorage.setItem("resetEmail", email);
            history.replace("/code", { actionType: ActionType.NewUser });
          } else {
            if (response!.data.responseMessage == "User already exist") {
              setIsDuplicateModal(true);
              setAccountError(true);
            } else {
              setIsDuplicateModal(false);
              setAccountError(true);
            }
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error: any) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
    }
  }
  console.log("actiontype forgotpasswod page", actionType);

  if (actionType != undefined && actionType === ActionType.NewUser) {
    return (
      <IonPage placeholder={undefined}>
        <TopLeftUserName
          headerText={"Account Registration"}
          actionType={ActionType.ExitUserSetup}
          exitModal={() => setShowModal1(true)}
        ></TopLeftUserName>

        <IonModal
          className="loader-modal"
          backdropDismiss={false}
          isOpen={loaderModal}
          placeholder={undefined}
        >
          <LoaderModalComponent
            setloaderModal={setloaderModal}
          ></LoaderModalComponent>
        </IonModal>

        <IonModal
          className="overall-center-modal-main-wrap"
          backdropDismiss={false}
          isOpen={cancelModal}
          placeholder={undefined}
        >
          <ExitModal
            setShowModal1={setShowModal1}
            actionType={ActionType.NewUser}
            reset={reset}
            isEdit={false}
          ></ExitModal>
        </IonModal>
        <IonModal
          className="overall-center-modal-main-wrap"
          backdropDismiss={false}
          isOpen={AccountError}
          placeholder={undefined}
        >
          <AccountErrorModal
            setAccountError={setAccountError}
            isDuplicateModal={isDuplicateModal}
          ></AccountErrorModal>
        </IonModal>
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid
            className="container login-pages-top-spacing"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="top-inner-sec login-pages-space">
                  {actionType === ActionType.NewUser && (
                    <>
                      <h1 className="mb-20">User Information</h1>
                      <p className="text-center">
                        Confirm user information for your account.
                      </p>
                    </>
                  )}
                </div>
                <form
                  onSubmit={handleSubmit((data) => {
                    clickChange(data.email);
                  })}
                  autoComplete="off"
                >
                  <div className={`field-wrap ${errors.email && "error-wrap"}`}>
                    <IonLabel className="label" placeholder={undefined}>
                      Email *
                    </IonLabel>
                    <IonInput
                      className="input-field input-email-error"
                      type="text"
                      placeholder="Enter Email"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^[\w+,]+(?:[.-][\w+,]+)*@\w+(?:[.-]\w+)*\.\w{2,6}$/i,
                      })}
                      onIonChange={(e) => {
                        handleChange(e);
                      }}
                    ></IonInput>
                    {errors.email && errors.email.type === "pattern" && (
                      <div className="error-wrap">
                        <p className="error-msg">Invalid Email</p>
                      </div>
                    )}
                    {errors.email &&
                      errors.email.type !== "required" &&
                      errors.email.type === "server" &&
                      errors.email.message && (
                        <ErrorTopToaster errorString={errors.email.message} />
                      )}
                  </div>
                  <div className="login-btn-fixed-bottom">
                    <div
                      className={`btn-wrap-sec extra-btn-space-wrap ${
                        actionType === ActionType.NewUser && "two-btns"
                      }`}
                    >
                      {actionType !== ActionType.NewUser && (
                        <IonButton
                          className="generic-btn active"
                          type="submit"
                          disabled={isDisabled}
                          placeholder={undefined}
                        >
                          Send
                        </IonButton>
                      )}
                      <IonButton
                        className="generic-btn generic-btn-outline"
                        onClick={() => {
                          setShowModal1(true);
                        }}
                        placeholder={undefined}
                      >
                        Cancel
                      </IonButton>
                      {actionType === ActionType.NewUser && (
                        <IonButton
                          className="generic-btn active"
                          type="submit"
                          disabled={isDisabled}
                          placeholder={undefined}
                        >
                          Confirm
                        </IonButton>
                      )}
                    </div>
                  </div>
                </form>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  } else if (actionType !== undefined && actionType !== ActionType.NewUser) {
    // forget
    return (
      <IonPage placeholder={undefined}>
        <TopLeftUserName
          headerText={"Password Reset"}
          actionType={ActionType.ExitForgotPassword}
          exitModal={() => setShowModal1(true)}
        ></TopLeftUserName>

        <IonModal
          className="loader-modal"
          backdropDismiss={false}
          isOpen={loaderModal}
          placeholder={undefined}
        >
          <LoaderModalComponent
            setloaderModal={setloaderModal}
          ></LoaderModalComponent>
        </IonModal>

        <IonModal
          className="overall-center-modal-main-wrap"
          backdropDismiss={false}
          isOpen={cancelModal}
          placeholder={undefined}
        >
          <ExitModal
            setShowModal1={setShowModal1}
            actionType={ActionType.ForgotPassword}
            reset={reset}
            isEdit={false}
          ></ExitModal>
        </IonModal>

        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid
            className="container login-pages-top-spacing"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="top-inner-sec login-pages-space">
                  <h1>Enter Email</h1>
                  <p>
                    Please enter the email associated with your account and
                    we’ll send you a code to verify.
                  </p>
                </div>
                <form
                  onSubmit={handleSubmit((data) => {
                    clickChange(data.email);
                  })}
                  autoComplete="off"
                >
                  <div className={`field-wrap ${errors.email && "error-wrap"}`}>
                    <IonLabel className="label" placeholder={undefined}>
                      Email *
                    </IonLabel>
                    <IonInput
                      className="input-field input-email-error"
                      type="text"
                      placeholder="Enter Email"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^[\w+,]+(?:[.-][\w+,]+)*@\w+(?:[.-]\w+)*\.\w{2,6}$/i,
                      })}
                      onIonChange={(e) => {
                        handleChange(e);
                      }}
                    ></IonInput>
                    {errors.email && errors.email.type === "pattern" && (
                      <div className="error-wrap">
                        <p className="error-msg">Invalid Email</p>
                      </div>
                    )}
                    {errors.email &&
                      errors.email.type !== "required" &&
                      errors.email.type === "server" &&
                      errors.email.message && (
                        <ErrorTopToaster errorString={errors.email.message} />
                      )}
                  </div>
                  <div></div>
                  <div
                    className={`btn-wrap-sec extra-btn-space-wrap ${
                      actionType === ActionType.NewUser && "two-btns"
                    }`}
                  >
                    {actionType != ActionType.NewUser && (
                      <IonButton
                        className="generic-btn active"
                        id="submit-button-forgot"
                        type="submit"
                        disabled={isDisabled}
                        placeholder={undefined}
                      >
                        Send
                      </IonButton>
                    )}
                    <IonButton
                      className="generic-btn generic-btn-outline"
                      onClick={() => {
                        setShowModal1(true);
                      }}
                      placeholder={undefined}
                    >
                      Cancel
                    </IonButton>
                  </div>
                </form>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  } else return <></>;
};
export default ForgotPassword;
